import ValidationInterface from '@/plans/common/validation-interface';
import { basePlanCategories, largeCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [this.current(largeCategories).require(basePlanCategories)];
  }

  async conflicts() {
    return [...largeCategories.map((c) => [c])];
  }
}
